import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C13SidePhotoContentCardProps = RenderingProps<
  C13SidePhotoContentCardFields,
  C13SidePhotoContentCardParams
>;

export type C13SidePhotoContentCardParams = {
  HeadlineTag?: string;
  Layout?: string;
  ImageSide?: string;
  SecondaryCtaStyle?: string;
} & AnchorTargetParams &
  TranslationOptionsParams &
  ImagePropertiesParams;

export interface C13SidePhotoContentCardFields {
  Image?: ImageField;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  PrimaryCtaButton?: LinkField;
  SecondaryCtaButton?: LinkField;
  PrimaryLink?: LinkField;
  SecondaryLink?: LinkField;
  ShouldLazyLoad?: boolean;
}
